import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function GetVendorsChosen() {   
    const [ results, setResults ] = useState([])
    useEffect(() => {
        axios.get('/api/vendors-chosen')
        .then(r => {
            setResults(r.data)
        })
    }, [])
    return(
        <table>
            <tr><th style={{padding: '3px'}}>Email</th><th style={{padding: '3px'}}>Name</th><th style={{padding: '3px'}}>Contact?</th><th style={{padding: '3px'}}>Style</th><th style={{padding: '3px'}}>Location</th><th style={{padding: '3px'}}>Venue</th><th style={{padding: '3px'}}>Date</th><th style={{padding: '3px'}}>Budget</th><th style={{padding: '3px'}}>Vendors</th></tr>
            {results.map(r => (
                <tr>
                    <td style={{padding: '3px'}}>{r.email}</td>
                    <td style={{padding: '3px'}}>{r.first_name} {r.last_name}</td>
                    <td style={{padding: '3px'}}>{r.can_contact ? 'Yes' : 'No'}</td>
                    <td style={{padding: '3px'}}>{r.style_ranking && r.style_ranking.map((s, index) => index != 3 ? s + ", " : s)}</td>
                    <td style={{padding: '3px'}}>{r.location_name}</td>
                    <td style={{padding: '3px'}}>{r.venue_name}</td>
                    {r.month && <td style={{padding: '3px'}}>{r.month}/{r.day}/{r.year}</td>}
                    {!r.month && <td></td>}
                    <td style={{padding: '3px'}}>{r.selected_budgets && r.selected_budgets.map((b, index) => index < r.selected_budgets.length -1 ? b + ", " : b)}</td>
                    <td style={{padding: '3px'}}>{r.vendor_types && r.vendor_types.map((v, index) => index < r.vendor_types.length - 1 ? v + ", " : v)}</td>
                </tr>
            ))}
        </table>
    )
}
